export default class roomTimeChange{

    private room_id: string;
    private modBookCalendar: any;
    private modRoomGames: any;
    private el_players: string;
    private timeSlotControl: any;
    private games_container_selector: string = '#games-container';

    /**
     * The constructor receives dependencies from roomInit.
     * Note: It receives the actual TomSelect control instance.
     */
    constructor(options: any){

        this.room_id = options.roomId;
        this.modBookCalendar = options.calendarModule;
        this.modRoomGames = options.gamesModule;
        this.el_players = options.playersSelector;
        this.timeSlotControl = options.timeSlotControl;

    }

    /**
     * Sets up the 'change' event listener on the time slot's TomSelect control.
     */
    initialize(){

        if(!this.timeSlotControl){

            console.error('Time Slot TomSelect control was not provided to the handler.');
            return;

        }

        // Use the .on() method from the TomSelect API
        this.timeSlotControl.on('change', this._handleTimeSlotChange.bind(this));

    }

    /**
     * This async function is triggered when the time slot selection changes.
     * @param {string} newTimeSlot - The new value selected by the user.
     * @private
     */
    private async _handleTimeSlotChange(newTimeSlot: string) {

        // Ignore if the selection is cleared or invalid
        if(!newTimeSlot) return;

        try{

            // Get other necessary values from the page
            const val_date = this.modBookCalendar.getDate('y-mm-dd');
            const playersElement: any = document.querySelector(this.el_players);
            const playersValue = playersElement ? playersElement.tomselect.getValue() : null;

            if(!val_date || playersValue === null){

                throw new Error('Could not retrieve current date or player count.');

            }

            // 1. Show preloader for the games section
            this.modRoomGames.showPreloader(this.games_container_selector);

            // 2. Reload the games with the new time slot value
            const response = await this.modRoomGames.get(this.room_id, val_date, newTimeSlot, playersValue);

            // 3. Render the new games list
            this.modRoomGames.renderGames(response.data.data, this.games_container_selector);

        }catch(error){

            console.error('Failed to update games after time slot change:', error);
            this.modRoomGames.showError(this.games_container_selector, 'Errore durante l\'aggiornamento dei giochi.');

        }

    }

}
